module.exports = __webpack_public_path__ + "img/no-data-img.fc120537.png";